import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerPendingApproval } from '../models/customer-pending-approval.model';
import { RestResponse } from '../models/restResponse.mode';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerPendingApprovalService {
  private readonly baseUrl = `${environment.base_url}/customers-pending`;

  constructor(private http: HttpClient) {}

  getAll(search: string, page: number): Observable<RestResponse<CustomerPendingApproval[]>> {
    return this.http.get<RestResponse<CustomerPendingApproval[]>>(
      `${this.baseUrl}/list?search=${search}&page=${page}`
    );
  }

  getById(id: number): Observable<RestResponse<CustomerPendingApproval>> {
    return this.http.get<RestResponse<CustomerPendingApproval>>(`${this.baseUrl}/find/${id}`);
  }

  approve(id: number): Observable<RestResponse<void>> {
    return this.http.patch<RestResponse<void>>(`${this.baseUrl}/approve/${id}`, {});
  }

  reject(id: number): Observable<RestResponse<void>> {
    return this.http.delete<RestResponse<void>>(`${this.baseUrl}/reject/${id}`, {});
  }
}

